import { defineComponent as r, computed as o, openBlock as a, createElementBlock as i, createElementVNode as e, toDisplayString as d, createCommentVNode as h, normalizeStyle as _ } from "vue";
const f = ["viewBox"], u = /* @__PURE__ */ e("mask", { id: "97b73106-2de7-408a-a857-a3bba074100d" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#97b73106-2de7-408a-a857-a3bba074100d)" }, p = { key: 0 }, k = /* @__PURE__ */ e("path", {
  fill: "#338af3",
  d: "M0 0h401.9L512 110.3V512H110.3L0 401.9z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#ffda44",
  d: "M401.9 0 0 401.9V449l63 63h47.3L512 110.3V63L449 0z"
}, null, -1), v = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "M449 0 0 449v63h63L512 63V0h-63z"
}, null, -1), x = /* @__PURE__ */ e("path", {
  fill: "#ffda44",
  d: "m136.4 78 13.8 42.4H195l-36 26.3 13.7 42.5-36.2-26.3-36 26.3 13.7-42.5L78 120.4h44.7z"
}, null, -1), w = { fill: "none" }, b = ["r"], V = /* @__PURE__ */ r({
  __name: "cd",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(c) {
    const t = c, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), n = o(() => 256 + t.strokeWidth / 2);
    return (y, z) => (a(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      u,
      e("g", m, [
        t.flagName ? (a(), i("title", p, d(t.flagName), 1)) : h("", !0),
        k,
        g,
        v,
        x
      ]),
      e("g", w, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: n.value,
          fill: "none",
          style: _({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, b)
      ])
    ], 8, f));
  }
});
export {
  V as default
};
//# sourceMappingURL=cd-60c60372.js.map
